import $, { speed } from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'slick-carousel';

import OneVideo from '@/modules/module-oneVideo';

import '../../styles/pages/home.scss';

export default Backbone.View.extend({
    
    initialize: function(opts){
        
        console.log('init home');
        
        var self = this;
        self.$content = self.$el;
        self.$body = $('body');
        self.$moduleA = self.$content.find('.hp-module-a');
        self.$moduleC = self.$content.find('.hp-module-c');
        self.$moduleD = self.$content.find('.hp-module-d');
        self.$moduleE = self.$content.find('.hp-module-e');
        self.$moduleF = self.$content.find('.hp-module-f');
        self.$moduleG = self.$content.find('.hp-module-g');

        self.$moduleA.length > 0 && _.each(self.$moduleA, (module) => {
            self.moduleA($(module));
        })

        self.$moduleC.length > 0 && _.each(self.$moduleC, (module) => {
            self.moduleC($(module));
        })

        self.$moduleD.length > 0 && _.each(self.$moduleD, (module) => {
            self.moduleD($(module));
        })

        self.$moduleE.length > 0 && _.each(self.$moduleE, (module) => {
            self.moduleE($(module));
        })

        self.$moduleF.length > 0 && _.each(self.$moduleF, (module) => {
            self.moduleF($(module));
        })

        self.$moduleG.length > 0 && _.each(self.$moduleG, (module) => {
            self.moduleG($(module));
        })
    },

    events: {
        
    },

    moduleA: function($module){
        const sectionId = $module.attr(`id`);
        // Only init OneVideo on legacy Vimeo .mp4 wrappers (have data-video-src).
        // Shopify-hosted + external (youtube/vimeo) video_url wrappers render their own player inline.
        const $videos = $module.find('.video-wrapper[data-video-src]');
        const layoutMode = $module.data(`layout`);

        // Only initialize carousel for 1-up (Full Hero) mode
        if (layoutMode && layoutMode !== '1' && layoutMode !== 1) {
            OneVideo.init({
                el: $videos,
                isResponsive: false,
                bgVideo: true,
                autoplay: true
            });
            return;
        }

        const autoplayEnabled = $module.data(`autoplay`);
        const autoplaySpeed = $module.data(`autoplay-speed`) * 1000;

        const slickOptions = $module.hasClass(`center-mode`) ? {
            dots: false,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows: true,
            centerMode: true,
            centerPadding: '10%',
            responsive: [
                {
                    breakpoint: ORW.responsiveSizes.medium,
                    settings: {
                        centerPadding: '5%',
                        arrows: false
                    }
                }
            ]
        } : {
            dots: true,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows: false,
            autoplay: autoplayEnabled || false,
            autoplaySpeed: autoplaySpeed || 8000,
        }

        $module.slick(slickOptions);
        
        OneVideo.init({
            el: $videos,
            isResponsive: false,
            bgVideo: true,
            autoplay: true
        });
    },

    moduleC: function($module){
        const self = this

        const $filterButtons = $module.find('.filters button')
        const $collectionsWrappers = $module.find('.collection-products')
        const $cta = $module.find('a.cta')

        $filterButtons.on('click', function(e){            
            $collectionsWrappers.addClass('hide');

            const $curr = $(e.currentTarget);
            const targetIndex = $curr.data('forloopindex');
            $collectionsWrappers.eq(targetIndex).removeClass('hide');

            $filterButtons.removeClass('active');
            $curr.addClass('active');

            $cta.attr('href', $curr.data('collectionurl'));
        });

    },

    moduleD: function($module){
        const self = this
        const sectionId = $module.attr(`id`)
        const $container = $module.find(`.blocks-container .inner-wrapper`)
        const $blocks = $module.find(`.block-container`)
        const $imagesSets = $module.find(`.images-container .images-set`)
        const $filterWrapper = $module.find(`.filters`)
        const $filterInnerWrapper = $module.find(`.filters .inner-wrapper`)
        const $filters = $module.find(`.filters button`)
        const $filterIndicator = $module.find(`.indicator`)

        // Set the indicator width
        if (window.innerWidth < ORW.responsiveSizes.medium) {
            const filterWidth = $filters.first().width()
            $filterIndicator.css(`width`, `${filterWidth}px`)
        }

        // For the indicator
        const offsetValue_v = (42-25)/2;

        const navActionEventKey = `click #${sectionId} .filters button`
        self.events[navActionEventKey] = e => {
            const $curr = $(e.currentTarget)

            if ($curr.hasClass(`active`)) return

            console.log(`Go to: ${$curr.data('filter')}`);

            if ($curr.data('filter')) {
                const targetBlockId = $curr.data('filter')

                if (window.innerWidth < ORW.responsiveSizes.medium) {
                const filterWidth = $curr.width()
                const $indicator = $module.find(`.indicator`)
                $indicator.css(`width`, `${filterWidth}px`)
            }

                const $targetBlock = $module.find(`.block-container[data-filter="${targetBlockId}"]`)
                const targetIndex = parseInt($blocks.index($targetBlock[0]))

                // console.log(targetIndex);
                let indicatorTop = `${ targetIndex / $blocks.length * 100 }%`
                let relativeX = $curr.offset().left - $filterInnerWrapper.offset().left
                if (targetIndex != 0 && targetIndex != ($filters.length - 1)) {
                    indicatorTop = `calc(${ targetIndex / $blocks.length * 100 }% + ${offsetValue_v}px)`
                } else if (targetIndex == ($filters.length - 1)) {
                    indicatorTop = `calc(${ targetIndex / $blocks.length * 100 }% + ${offsetValue_v*2}px)`
                }

                $blocks.removeClass(`is-active`)
                $filters.removeClass(`active`)
                $imagesSets.removeClass(`is-active`)

                $container.css(`transform`, `translateX(-${ targetIndex / $blocks.length * 100 }%)`)
                $filterIndicator.css(`top`, `${ indicatorTop }`)
                $filterIndicator.css(`left`, `${ relativeX }px`)

                $targetBlock.addClass(`is-active`)
                $curr.addClass(`active`)
                $module.find(`.images-set[data-filter="${targetBlockId}"]`).addClass(`is-active`)
            }
            
        }
        self.delegateEvents();
    },

    moduleE: function($module){
        const self = this
        const sectionId = $module.attr(`id`)
        const $container = $module.find(`> .container`)
        const slickOptions = {
            dots: false,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            autoplay: $module.data('autoplay'),
            autoplaySpeed: $module.data('autoplay-speed')
        }
        $container.slick(slickOptions);
        
        $container.on('touchstart', e => {
            $container.slick('slickPlay');
        });	
        /*
            This module has multiple in-content dummy slider navigation, we need to build sync between the dummy ones and the real one
        */
        $container.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $container.find(`.slick-dots-dummy li`).map((index, element) => {
                const $el = $(element)
                const $button = $el.find(`button`)
                if ($button.data(`index`) != `${nextSlide}`) {
                    $el.removeClass(`slick-active`)
                    $button.attr(`tabindex`, `-1`).removeAttr(`aria-selected`)
                } else {
                    $el.addClass(`slick-active`)
                    $button.attr({
                        "tabindex": `0`,
                        "aria-selected": `true`
                    })
                }
            })
        });

        const navActionEventKey = `click #${sectionId} .slick-dots-dummy button`
        self.events[navActionEventKey] = e => {
            const $curr = $(e.currentTarget)

            if ($curr.parent().hasClass(`slick-active`)) return

            const goToIndex = $curr.data(`index`)
            $container.slick(`slickGoTo`, goToIndex)
        }
        self.delegateEvents();
    },

    moduleF: function($module){
        const $container = $module.find(`> .container`)
        const slickOptions = {
            dots: true,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows: false,
        }

        $container.slick(slickOptions);
    },
    
    moduleG: function($module){
        const imgCTA = document.querySelector(".img-cta");
        if (!imgCTA) return;
        
        const openImg = imgCTA.textContent;
        const closeImg = imgCTA.getAttribute("data-close");
        const img = document.querySelector(".img-container");
        if ( window.innerWidth < 768 ) {
            const clone = document.querySelector(".img-container img").cloneNode();
            clone.style.visibility = 'hidden';
            clone.style.position = 'absolute';
            clone.style.display = 'block';
            clone.style.top = '-9999px';
            clone.style.maxWidth = 'initial';
            clone.style.width = '275%';
            document.body.appendChild(clone);
            const cloneheight = clone.offsetHeight;
            document.body.removeChild(clone);
            img.style.height = `${cloneheight}px`;
        }
        imgCTA.addEventListener('click', function() {
            const isExpanded = img.classList.toggle('active');
            if (isExpanded) {
                imgCTA.textContent = closeImg;
            } else {
                imgCTA.textContent = openImg;
            }
        });
    },

    destroy: function() {
        var self = this;
        self.undelegateEvents();
    },
    
    responsive: function () {
        var self = this;
        ORW.utilities.mediaCheck(function () {
            // Desktop actions
        }, function () {
            // Mobile actions
        })
    },
    
    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    }
});